<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>
<script>
import Utils from "./utils/Utils";
export default {
  name: "App",
  data(){
    return {
      app:"",
    };
  },
  mounted: function() {
    this.app = Utils.getApp();
    document.body.addEventListener('focusout',()=>{
      document.body.scrollIntoView();
    });
  }
}
</script>
<style>
#app {
  margin: 0px;
  padding: 0px;
  flex: 1;
  overflow: hidden !important;
  display: flex;
  /*justify-content: center;*/
  flex-direction: column;
  height: 100vh;
}
*::-webkit-scrollbar {
  width: 0;
}
</style>
